import React, { memo, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import EChartsReact from 'echarts-for-react';
import { costGaugeOptions } from 'services/glass-management/coq';
import { themeColors } from 'helpers/utils';

const FailureCostGauge = ({ data }) => {
    const [options, setOptions] = useState(costGaugeOptions);
    useEffect(() => {
        const series = {
            ...options.series[0],
            data: [
                {
                    value: data?.dateFails?.TotalCost || 0,
                    name: 'Total',
                    title: {
                        offsetCenter: ['0%', '-60%']
                    },
                    detail: {
                        valueAnimation: true,
                        offsetCenter: ['0%', '-40%']
                    },
                    itemStyle: {
                        color: themeColors.success
                    }
                },
                {
                    value: data?.dateFails?.TotalFailureCost || 0,
                    name: 'Reject',
                    title: {
                        offsetCenter: ['0%', '-15%']
                    },
                    detail: {
                        valueAnimation: true,
                        offsetCenter: ['0%', '5%']
                    },
                    itemStyle: {
                        color: themeColors.danger
                    }
                },
            ],
            max: data?.dateFails?.TotalCost || 0
        }
        setOptions({ ...options, series: series, });
    }, [data]);

    return (
        <Row>
            <Row className='ms-2 mt-3 mb-0 pb-0'>
                <Col><span className='p-2 h5 float-start'>Cost Failure Rate</span></Col>
            </Row>
            <EChartsReact option={options} />
        </Row>
    );
};

FailureCostGauge.propTypes = {
    data: PropTypes.object
};
export default memo(FailureCostGauge);